import { render, staticRenderFns } from "./ReplyToChip.vue?vue&type=template&id=47c8542a&"
import script from "./ReplyToChip.vue?vue&type=script&lang=js&"
export * from "./ReplyToChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports